module.exports = __webpack_public_path__ + "static/media/district3.d0ec6f85.pdf";